import { Component, ElementRef, HostListener, Renderer2, ViewChild} from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgClass, NgIf } from '@angular/common';
import { AuthService } from 'src/app/auth/auth.service';
import { NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { environment } from 'src/environments/environment';
import { MatRippleModule } from '@angular/material/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-main-toolbar',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    MatIconModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    MatRippleModule,
    RouterLink,
    RouterLinkActive,
    MatProgressSpinnerModule
  ],
  templateUrl: './main-toolbar.component.html',
  styleUrl: './main-toolbar.component.scss'
})
export class MainToolbarComponent {

  title = 'GUIDOZORN-ADMIN'
  @ViewChild('mainToolbar', ) mainToolbar!: ElementRef;
  
  public showMainMenuTooltip = false;
  public isLoading: boolean = true;
  public connected: boolean = false;
  public showMenu: boolean = false;

  private userUpdatedSubscription: Subscription | null = null;

  onlineListener!: () => void;
  offlineListener!: () => void;

  constructor(
    public auth: AuthService,
    public router: Router,
    private renderer: Renderer2
  ) {
    this.title = this.title + (environment.production ? " PROD" : " DEV");
    this.connected = navigator.onLine; // check connection
  }

  ngOnInit() {
    this.checkWindowSize();
    this.onlineListener = this.renderer.listen('window', 'online', this.onOnline.bind(this));
    this.offlineListener = this.renderer.listen('window', 'offline', this.onOffline.bind(this));
    this.waitAuthLoaded();
  }

  ngAfterViewInit() {
    if ( !environment.production ) {
      const nativeElement = (this.mainToolbar as any)._elementRef.nativeElement;
      this.renderer.addClass(nativeElement, 'dev');
    }
  }

  ngOnDestroy() {
    this.onlineListener?.();
    this.offlineListener?.();
    this.userUpdatedSubscription?.unsubscribe();
    this.userUpdatedSubscription = null;
  }

  private async waitAuthLoaded() {
    try {
      await this.auth.isInitialized;
      this.isLoading = false;
      this.userUpdatedSubscription = this.auth.uid$.subscribe({
        next: () => this.setShowMenu()
      });
      this.setShowMenu();
    } catch (error) {
      console.error('Failed to initialize user:', error);
    }
  }

  private setShowMenu() {
    const isAuthenticated = this.auth.isAuthenticated;
    this.showMenu = !this.isLoading && isAuthenticated;
  }
  
  private onOnline() { this.connected = true; }
  private onOffline() { this.connected = false; }


  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.checkWindowSize();
  }

  private checkWindowSize(): void {
    this.showMainMenuTooltip = window.innerWidth < 580;
  }
  
}